import moment from 'moment';

//! should be using specific type, refactor type in cash in page first
/**
 *
 * @deprecated use moment or util/time
 */
export const getDateFromString = (dateString: any) => {
  if (!dateString) {
    return null;
  }

  const date = moment(decodeURIComponent(dateString));
  return date.isValid() ? date.toDate() : null;
};

/**
 *
 * @deprecated use moment or util/time
 */
export const dateFormatNow = () => {
  return moment().toDate();
};

/**
 *
 * @deprecated use moment or util/time
 */
//! should refactor unknown parameter first for some functions which refer to this
export default (date: any) => {
  return moment(date).add(7, 'hours');
};
